import config from '../../config'
import { valid, refreshToken, ajax, serviceAjax, header } from './base'

let activity = {

}
export default activity



// WEBPACK FOOTER //
// ./src/common/api/activity.js